export const currency: { [key: number]: string } = {
  1: 'eur',
  2: 'usd',
  3: 'gbp',
  4: 'twd',
};
